(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagItemBottomSheetController', OrderBagItemBottomSheetController);

    OrderBagItemBottomSheetController.$inject = ['$mdBottomSheet', 'entity'];

    function OrderBagItemBottomSheetController($mdBottomSheet, entity) {
        var vm = this;

        vm.orderBagItem = entity.orderBagItem;
        vm.orderBag = entity.orderBag;
        vm.constStatus = entity.constStatus;
        vm.showReplaceTime = entity.showReplaceTime;

        vm.itemClick = itemClick;
        vm.close = close;

        function itemClick(txt) {
            $mdBottomSheet.hide(txt);
        }

        function close() {
            $mdBottomSheet.hide();
        }
    }
})();
